import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface FaixaDistancia {
    id: number | null
    distanciaMaxima: string
    taxaEntrega: string
    taxaEntregaNoturna: string | null
    minimoEntregaGratis: string | null
    taxaEntregador: string | null
    versao: number | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

const ErroRequisicao = function (error: { message?: string }): string | false {
    if (error.message === "Network Error") return "Verifique sua conexão!"
    if (error.message) return "Erro: " + error.message
    return false
}

export const obterFaixasDistancia = async function (
    authorization: string,
    idEstabelecimento: number
): Promise<FaixaDistancia[] | ErroApi> {
    try {
        const response = await api
            .get<FaixaDistancia[] | RespostaErroRaw>(`endereco/distancias/${idEstabelecimento}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as FaixaDistancia[]
    } catch (error) {
        RegistrarLogErro(error, "obterFaixasDistancia", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarFaixasDistancia = async function (
    authorization: string,
    idEstabelecimento: number,
    faixas: FaixaDistancia[]
): Promise<FaixaDistancia[] | ErroApi> {
    try {
        const response = await api
            .post<FaixaDistancia[] | RespostaErroRaw>(
                `endereco/distancias/${idEstabelecimento}`,
                faixas,
                { headers: { "Content-Type": "application/json", Authorization: authorization } }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as FaixaDistancia[]
    } catch (error) {
        RegistrarLogErro(error, "salvarFaixasDistancia", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const excluirFaixasDistancia = async function (
    authorization: string,
    idEstabelecimento: number,
    faixas: FaixaDistancia[]
): Promise<FaixaDistancia[] | ErroApi> {
    try {
        const response = await api
            .delete<FaixaDistancia[] | RespostaErroRaw>(
                `endereco/distancias/${idEstabelecimento}`,
                {
                    data: faixas,
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                const msg = ErroRequisicao(error)
                return {
                    data: { codErro: 1, mensagem: msg || "Erro desconhecido" } as RespostaErroRaw,
                }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as FaixaDistancia[]
    } catch (error) {
        RegistrarLogErro(error, "excluirFaixasDistancia", String(idEstabelecimento))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
